jQuery(document).ready(function($){
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		$('.descargables').slick();
		$('.c-hamburger').click(function(e){
			e.preventDefault();
			$(this).toggleClass('is-active');
			$('.mobile_menu_wrap').toggleClass('hide');
		});
	}
});
